/* eslint i18next/no-literal-string: 0 */
import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'

import { closeMenu, switchPageLoading } from '../../../store/common/commonSlice'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import LangLinks from '../../ui/langLinks'

import { IconMail, IconFileText, IconCookie, IconDeviceTv, IconChevronRight } from '@tabler/icons-react'

const MenuNewRight: React.FC = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const handleMenuClick = () => {
        dispatch(closeMenu())
        dispatch(switchPageLoading())
    }

    const infoLinks = [
        {
            label: t('Contact'),
            icon: <IconMail size={20} />,
            path: createLocalizedPath(paths.contact.path),
            isLink: true
        },
        {
            label: t('CGU'),
            icon: <IconFileText size={20} />,
            path: paths.cgu.path,
            isLink: true
        }
    ]

    const bobLinks = [
        {
            label: 'BobTV',
            icon: <IconDeviceTv size={20} />,
            href: 'https://www.bobtv.fr'
        }
    ]

    return (
        <div className="menuNewRight">
            <div className="menuNewRight__section">
                <p className="menuNewRight__title">{t('Les sites de Bob')}</p>
                <div className="menuNewRight__items">
                    {bobLinks.map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            target="_blank"
                            rel="noreferrer"
                            className="menuNewRight__item"
                        >
                            <span className="menuNewRight__itemIcon">{link.icon}</span>
                            <span className="menuNewRight__itemLabel">{link.label}</span>
                            <IconChevronRight size={16} className="menuNewRight__itemArrow" />
                        </a>
                    ))}
                </div>
            </div>

            <div className="menuNewRight__section">
                <p className="menuNewRight__title">{t('Help & information')}</p>
                <div className="menuNewRight__items">
                    {infoLinks.map((link) => (
                        <Link
                            key={link.label}
                            to={{ pathname: link.path }}
                            onClick={handleMenuClick}
                            className="menuNewRight__item"
                        >
                            <span className="menuNewRight__itemIcon">{link.icon}</span>
                            <span className="menuNewRight__itemLabel">{link.label}</span>
                            <IconChevronRight size={16} className="menuNewRight__itemArrow" />
                        </Link>
                    ))}
                    <button
                        className="menuNewRight__item"
                        onClick={() => {
                            Cookies.remove('cookieConsent')
                            window.location.reload()
                        }}
                    >
                        <span className="menuNewRight__itemIcon">
                            <IconCookie size={20} />
                        </span>
                        <span className="menuNewRight__itemLabel">{t('Cookie Management')}</span>
                        <IconChevronRight size={16} className="menuNewRight__itemArrow" />
                    </button>
                </div>
            </div>

            <div className="menuNewRight__section menuNewRight__section--lang">
                <LangLinks />
            </div>
        </div>
    )
}

export default MenuNewRight
